<template>
    <fieldset :class="fieldsetClasse">
        <label v-if="label" v-html="label" class="label"></label>
        <input v-if="mask"
               ref="inputText"
               :id="id"
               :type="realTipo"
               class="form-control rounded-0"
               :class="classe"
               :placeholder="placeholder"
               @blur="blur"
               @focus="focus"
               @input="$emit('input', $event.target.value)"
               @keyup.enter="enterFunction"
               :value="value"
               :required="required"
               :disabled="disabled"
               :autofocus="autofocus"
               v-mask="mask">

        <input v-else
               ref="inputText"
               :id="id"
               :type="realTipo"
               class="form-control rounded-0"
               :class="classe"
               :placeholder="placeholder"
               @blur="blur"
               @focus="focus"
               @input="$emit('input', $event.target.value)"
               @keyup.enter="enterFunction"
               :value="value"
               :required="required"
               :autofocus="autofocus"
               :disabled="disabled">

        <span v-if="useIconEyes" class="input-group-addon" id="basic-addon1">
          <i v-if="viewPhrase" class="ion ion-eye-disabled" @click="escondeSenha"></i>
          <i v-else class="ion ion-eye" @click="mostraSenha"></i>
        </span>

        <p v-for="error in errors" class="text-danger" v-html="error"></p>
    </fieldset>
</template>

<script>
    import {mask} from 'vue-the-mask'
    export default {
        directives: {
          mask
        },
        props: {
          value: {
            type: [String,Number],
            default: null,
          },
          label: {
            type: String,
            default: null,
          },
          placeholder: {
            type: String,
            default: '',
          },
          tipo: {
            type: String,
            default: 'text',
          },
          classe: {
            type: String,
            default: null,
          },
          useIconEyes: {
            type: Boolean,
            default: false,
          },
          required: {
            type: Boolean,
            default: false,
          },
          disabled: {
            type: Boolean,
            default: false,
          },
          autofocus: {
            type: Boolean,
            default: false,
          },
          fieldsetClasse: {
            type: String,
            default: 'col',
          },
          id: {
            type: String,
            default: () => {
              return 'text_' + _.toString(Math.floor((Math.random() * 10000) + 1))
            },
          },
          mask: {
            type: [String,Array],
            default: null,
          },
          blur: {
            type: Function,
            default: () => {
              return false
            }
          },
          focus: {
            type: Function,
            default: () => {
              return false
            }
          },
        },
        watch: {
          '$root.errorsForm': function () {
            if(this.$root.errorsForm.hasOwnProperty(this.name)){
              this.errors = _.cloneDeep(this.$root.errorsForm[this.name])
              if(this.$root.alert.hasOwnProperty('extend') && this.$root.alert.extend) {
                  this.$root.alert.texto += "<br><b>" + this.label + ':</b> ' + _.join(_.values(this.errors), ';')
              }
              delete this.$root.errorsForm[this.name]
            }
            else{
              this.errors = {}
            }
          },
          'value': function () {
            this.errors = {}
          }
        },
        data() {
          return {
            name: null,
            errors: {},
            viewPhrase: false,
            realTipo: this.tipo,
          }
        },
        methods: {
            enterFunction() {
                this.$emit('enter')
            },
            getRef() {
              return this.$refs.inputText
            },
            mostraSenha() {
              this.viewPhrase = true
              this.realTipo = 'text'
            },
            escondeSenha() {
              this.viewPhrase = false
              this.realTipo = this.tipo
            },
        },
        created() {
          let expression = _.split(this.$vnode.data.model.expression, '.')
          this.name = _.last(expression)
        }
    }
</script>

<style type="text/css">
    .label{
        color: rgba(0,0,0,.7);
        font-size: .8em;
    }
  #basic-addon1{
    display: block;
    width: 9%;
    text-align: center;
    position: absolute;
    right: 16px;
    top: 38px;
    background: #FFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/text.vue